import React from 'react'
import PropTypes from 'prop-types'
import {LeftOutlined, RightOutlined} from '@ant-design/icons'
import {weeksInYear} from 'lib/dateHelpers'

import './index.css'

const WeekNumberPicker = ({week, year, onChange}) => {
  function navigate(direction) {
    let newWeek
    switch (direction) {
      case 'PREV':
        newWeek = week - 1
        break
      case 'NEXT':
        newWeek = week + 1
        break
      // no default
    }

    if (newWeek < 1) {
      const newYear = year - 1
      onChange(weeksInYear(newYear), newYear)
    } else if (newWeek > weeksInYear(year)) {
      onChange(1, year + 1)
    } else {
      onChange(newWeek, year)
    }
  }

  return (
    <div className="week-number-picker">
      <div className="trigger prev-week">
        <LeftOutlined
          onClick={() => navigate('PREV')}
        />
      </div>
      <div className="current-week">
        Uke {week}
      </div>
      <div className="trigger next-week">
        <RightOutlined
          onClick={() => navigate('NEXT')}
        />
      </div>
    </div>
  )
}

WeekNumberPicker.propTypes = {
  week: PropTypes.number.isRequired,
  year: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default WeekNumberPicker
